import { render } from "./MediaViewerModal.vue?vue&type=template&id=43c89887&scoped=true"
import script from "./MediaViewerModal.vue?vue&type=script&lang=js"
export * from "./MediaViewerModal.vue?vue&type=script&lang=js"

import "./MediaViewerModal.vue?vue&type=style&index=0&id=43c89887&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c89887"]])

export default __exports__